/**
 * Centralized theme configuration - Single Source of Truth
 * This is the ONLY place where design tokens should be defined
 */

export const theme = {
  // Color palette - OKLCH values (Light Mode - Twitter Theme)
  colors: {
    background: "oklch(1.0000 0 0)",
    foreground: "oklch(0.1884 0.0128 248.5103)",
    card: "oklch(0.9784 0.0011 197.1387)",
    cardForeground: "oklch(0.1884 0.0128 248.5103)",
    popover: "oklch(1.0000 0 0)",
    popoverForeground: "oklch(0.1884 0.0128 248.5103)",
    primary: "oklch(0.6723 0.1606 244.9955)",
    primaryForeground: "oklch(1.0000 0 0)",
    secondary: "oklch(0.1884 0.0128 248.5103)",
    secondaryForeground: "oklch(1.0000 0 0)",
    muted: "oklch(0.9222 0.0013 286.3737)",
    mutedForeground: "oklch(0.1884 0.0128 248.5103)",
    accent: "oklch(0.9392 0.0166 250.8453)",
    accentForeground: "oklch(0.6723 0.1606 244.9955)",
    destructive: "oklch(0.6188 0.2376 25.7658)",
    destructiveForeground: "oklch(1.0000 0 0)",
    border: "oklch(0.9317 0.0118 231.6594)",
    input: "oklch(0.8500 0.0150 231.6594)",
    ring: "oklch(0.6818 0.1584 243.3540)",
    chart1: "oklch(0.6723 0.1606 244.9955)",
    chart2: "oklch(0.6907 0.1554 160.3454)",
    chart3: "oklch(0.8214 0.1600 82.5337)",
    chart4: "oklch(0.7064 0.1822 151.7125)",
    chart5: "oklch(0.5919 0.2186 10.5826)",
    sidebar: "oklch(0.9784 0.0011 197.1387)",
    sidebarForeground: "oklch(0.1884 0.0128 248.5103)",
    sidebarPrimary: "oklch(0.6723 0.1606 244.9955)",
    sidebarPrimaryForeground: "oklch(1.0000 0 0)",
    sidebarAccent: "oklch(0.9392 0.0166 250.8453)",
    sidebarAccentForeground: "oklch(0.6723 0.1606 244.9955)",
    sidebarBorder: "oklch(0.9271 0.0101 238.5177)",
    sidebarRing: "oklch(0.6818 0.1584 243.3540)",
    success: "oklch(0.7000 0.1500 150.0000)",
    successForeground: "oklch(0.2000 0.1000 150.0000)",
    error: "oklch(0.6188 0.2376 25.7658)",
    errorForeground: "oklch(1.0000 0 0)",
    warning: "oklch(0.7500 0.1500 60.0000)",
    warningForeground: "oklch(0.2500 0.1000 60.0000)",
    info: "oklch(0.6723 0.1606 244.9955)",
    infoForeground: "oklch(1.0000 0 0)",
  },

  // Dark mode color palette - OKLCH values
  darkColors: {
    background: "oklch(0 0 0)",
    foreground: "oklch(0.9328 0.0025 228.7857)",
    card: "oklch(0.2097 0.0080 274.5332)",
    cardForeground: "oklch(0.8853 0 0)",
    popover: "oklch(0 0 0)",
    popoverForeground: "oklch(0.9328 0.0025 228.7857)",
    primary: "oklch(0.6692 0.1607 245.0110)",
    primaryForeground: "oklch(1.0000 0 0)",
    secondary: "oklch(0.9622 0.0035 219.5331)",
    secondaryForeground: "oklch(0.1884 0.0128 248.5103)",
    muted: "oklch(0.2090 0 0)",
    mutedForeground: "oklch(0.5637 0.0078 247.9662)",
    accent: "oklch(0.1928 0.0331 242.5459)",
    accentForeground: "oklch(0.6692 0.1607 245.0110)",
    destructive: "oklch(0.6188 0.2376 25.7658)",
    destructiveForeground: "oklch(1.0000 0 0)",
    border: "oklch(0.2674 0.0047 248.0045)",
    input: "oklch(0.4000 0.0200 244.8244)",
    ring: "oklch(0.6818 0.1584 243.3540)",
    chart1: "oklch(0.6723 0.1606 244.9955)",
    chart2: "oklch(0.6907 0.1554 160.3454)",
    chart3: "oklch(0.8214 0.1600 82.5337)",
    chart4: "oklch(0.7064 0.1822 151.7125)",
    chart5: "oklch(0.5919 0.2186 10.5826)",
    sidebar: "oklch(0.2097 0.0080 274.5332)",
    sidebarForeground: "oklch(0.8853 0 0)",
    sidebarPrimary: "oklch(0.6818 0.1584 243.3540)",
    sidebarPrimaryForeground: "oklch(1.0000 0 0)",
    sidebarAccent: "oklch(0.1928 0.0331 242.5459)",
    sidebarAccentForeground: "oklch(0.6692 0.1607 245.0110)",
    sidebarBorder: "oklch(0.3795 0.0220 240.5943)",
    sidebarRing: "oklch(0.6818 0.1584 243.3540)",
    success: "oklch(0.7000 0.1500 150.0000)",
    successForeground: "oklch(0.2000 0.1000 150.0000)",
    error: "oklch(0.6188 0.2376 25.7658)",
    errorForeground: "oklch(1.0000 0 0)",
    warning: "oklch(0.7500 0.1500 60.0000)",
    warningForeground: "oklch(0.2500 0.1000 60.0000)",
    info: "oklch(0.6723 0.1606 244.9955)",
    infoForeground: "oklch(1.0000 0 0)",
  },

  // Spacing scale (rem-based for accessibility)
  spacing: {
    DEFAULT: "0.25rem",
    xs: "0.25rem",    // 4px
    sm: "0.5rem",     // 8px
    md: "1rem",       // 16px
    lg: "1.5rem",     // 24px
    xl: "2rem",       // 32px
    "2xl": "3rem",    // 48px
    "3xl": "4rem",    // 64px
    "4xl": "6rem",    // 96px
  },

  // Typography scale
  typography: {
    fontFamily: {
      sans: "Open Sans, sans-serif",
      serif: "Georgia, serif",
      mono: "Menlo, monospace",
    },
    fontSize: {
      xs: "0.75rem",      // 12px
      sm: "0.875rem",     // 14px
      base: "1rem",       // 16px
      lg: "1.125rem",     // 18px
      xl: "1.25rem",      // 20px
      "2xl": "1.5rem",    // 24px
      "3xl": "1.875rem",  // 30px
      "4xl": "2.25rem",   // 36px
      "5xl": "3rem",      // 48px
    },
    lineHeight: {
      tight: "1.25",
      normal: "1.5",
      relaxed: "1.75",
    },
    fontWeight: {
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
    },
    letterSpacing: {
      normal: "0em",
    },
  },

  // Border radius
  radius: {
    none: "0",
    DEFAULT: "1.3rem", // Base radius
    sm: "calc(1.3rem - 4px)",
    md: "calc(1.3rem - 2px)",
    lg: "1.3rem",
    xl: "calc(1.3rem + 4px)",
    "2xl": "1.5rem",   // 24px
    full: "9999px",
  },

  // Box shadows (Light Mode)
  shadows: {
    "2xs": "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    xs: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    sm: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    DEFAULT: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    md: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 2px 4px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    lg: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 4px 6px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    xl: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 8px 10px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    "2xl": "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    none: "0 0 #0000",
  },

  // Box shadows (Dark Mode)
  darkShadows: {
    "2xs": "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    xs: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    sm: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    DEFAULT: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    md: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 2px 4px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    lg: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 4px 6px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    xl: "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 8px 10px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    "2xl": "0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)",
    inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    none: "0 0 #0000",
  },

  // Transitions
  transitions: {
    fast: "150ms",
    base: "200ms",
    slow: "300ms",
    slower: "500ms",
  },

  // Z-index scale
  zIndex: {
    base: "0",
    dropdown: "1000",
    sticky: "1020",
    fixed: "1030",
    modalBackdrop: "1040",
    modal: "1050",
    popover: "1060",
    tooltip: "1070",
  },
}

/**
 * Get CSS variable string for a color
 * @param {string} color - Color value in OKLCH format (e.g., "oklch(1 0 0)")
 * @returns {string} CSS oklch() value
 */
export function getColorVar(color) {
  return color
}

/**
 * Get a color value from the theme
 * @param {string} colorKey - Key from theme.colors (e.g., "primary", "background")
 * @returns {string} CSS oklch() value
 */
export function getColor(colorKey) {
  const color = theme.colors[colorKey]
  return color ? getColorVar(color) : undefined
}

/**
 * Get a spacing value from the theme
 * @param {string} key - Key from theme.spacing (e.g., "md", "xl")
 * @returns {string} CSS rem value
 */
export function getSpacing(key) {
  return theme.spacing[key]
}

/**
 * Generate complete CSS with all theme variables
 * @returns {string} CSS string with all custom properties
 */
export function generateThemeCSS() {
  const { colors, darkColors, spacing, typography, radius, shadows, darkShadows, transitions, zIndex } = theme
  
  return `
    :root {
      /* Colors */
      --background: ${colors.background};
      --foreground: ${colors.foreground};
      --card: ${colors.card};
      --card-foreground: ${colors.cardForeground};
      --popover: ${colors.popover};
      --popover-foreground: ${colors.popoverForeground};
      --primary: ${colors.primary};
      --primary-foreground: ${colors.primaryForeground};
      --secondary: ${colors.secondary};
      --secondary-foreground: ${colors.secondaryForeground};
      --muted: ${colors.muted};
      --muted-foreground: ${colors.mutedForeground};
      --accent: ${colors.accent};
      --accent-foreground: ${colors.accentForeground};
      --destructive: ${colors.destructive};
      --destructive-foreground: ${colors.destructiveForeground};
      --border: ${colors.border};
      --input: ${colors.input};
      --ring: ${colors.ring};
      --chart-1: ${colors.chart1};
      --chart-2: ${colors.chart2};
      --chart-3: ${colors.chart3};
      --chart-4: ${colors.chart4};
      --chart-5: ${colors.chart5};
      --sidebar: ${colors.sidebar};
      --sidebar-background: ${colors.sidebar};
      --sidebar-foreground: ${colors.sidebarForeground};
      --sidebar-primary: ${colors.sidebarPrimary};
      --sidebar-primary-foreground: ${colors.sidebarPrimaryForeground};
      --sidebar-accent: ${colors.sidebarAccent};
      --sidebar-accent-foreground: ${colors.sidebarAccentForeground};
      --sidebar-border: ${colors.sidebarBorder};
      --sidebar-ring: ${colors.sidebarRing};
      --success: ${colors.success};
      --success-foreground: ${colors.successForeground};
      --error: ${colors.error};
      --error-foreground: ${colors.errorForeground};
      --warning: ${colors.warning};
      --warning-foreground: ${colors.warningForeground};
      --info: ${colors.info};
      --info-foreground: ${colors.infoForeground};

      /* Fonts */
      --font-sans: ${typography.fontFamily.sans};
      --font-serif: ${typography.fontFamily.serif};
      --font-mono: ${typography.fontFamily.mono};

      /* Border Radius */
      --radius: ${radius.DEFAULT};
      --radius-none: ${radius.none};
      --radius-sm: calc(var(--radius) - 4px);
      --radius-md: calc(var(--radius) - 2px);
      --radius-lg: var(--radius);
      --radius-xl: calc(var(--radius) + 4px);
      --radius-2xl: ${radius["2xl"]};
      --radius-full: ${radius.full};

      /* Shadows */
      --shadow-x: 0px;
      --shadow-y: 2px;
      --shadow-blur: 0px;
      --shadow-spread: 0px;
      --shadow-opacity: 0;
      --shadow-color: rgba(29,161,242,0.15);
      --shadow-2xs: ${shadows["2xs"]};
      --shadow-xs: ${shadows.xs};
      --shadow-sm: ${shadows.sm};
      --shadow: ${shadows.DEFAULT};
      --shadow-md: ${shadows.md};
      --shadow-lg: ${shadows.lg};
      --shadow-xl: ${shadows.xl};
      --shadow-2xl: ${shadows["2xl"]};
      --shadow-inner: ${shadows.inner};

      /* Typography */
      --text-xs: ${typography.fontSize.xs};
      --text-sm: ${typography.fontSize.sm};
      --text-base: ${typography.fontSize.base};
      --text-lg: ${typography.fontSize.lg};
      --text-xl: ${typography.fontSize.xl};
      --text-2xl: ${typography.fontSize["2xl"]};
      --text-3xl: ${typography.fontSize["3xl"]};
      --text-4xl: ${typography.fontSize["4xl"]};
      --text-5xl: ${typography.fontSize["5xl"]};

      --leading-tight: ${typography.lineHeight.tight};
      --leading-normal: ${typography.lineHeight.normal};
      --leading-relaxed: ${typography.lineHeight.relaxed};

      --font-normal: ${typography.fontWeight.normal};
      --font-medium: ${typography.fontWeight.medium};
      --font-semibold: ${typography.fontWeight.semibold};
      --font-bold: ${typography.fontWeight.bold};
      --font-extrabold: ${typography.fontWeight.extrabold};

      --tracking-normal: ${typography.letterSpacing.normal};

      /* Spacing */
      --spacing: ${spacing.DEFAULT};
      --spacing-xs: ${spacing.xs};
      --spacing-sm: ${spacing.sm};
      --spacing-md: ${spacing.md};
      --spacing-lg: ${spacing.lg};
      --spacing-xl: ${spacing.xl};
      --spacing-2xl: ${spacing["2xl"]};
      --spacing-3xl: ${spacing["3xl"]};
      --spacing-4xl: ${spacing["4xl"]};

      /* Transitions */
      --transition-fast: ${transitions.fast};
      --transition-base: ${transitions.base};
      --transition-slow: ${transitions.slow};
      --transition-slower: ${transitions.slower};

      /* Z-Index */
      --z-base: ${zIndex.base};
      --z-dropdown: ${zIndex.dropdown};
      --z-sticky: ${zIndex.sticky};
      --z-fixed: ${zIndex.fixed};
      --z-modal-backdrop: ${zIndex.modalBackdrop};
      --z-modal: ${zIndex.modal};
      --z-popover: ${zIndex.popover};
      --z-tooltip: ${zIndex.tooltip};
    }

    .dark {
      /* Dark Mode Colors */
      --background: ${darkColors.background};
      --foreground: ${darkColors.foreground};
      --card: ${darkColors.card};
      --card-foreground: ${darkColors.cardForeground};
      --popover: ${darkColors.popover};
      --popover-foreground: ${darkColors.popoverForeground};
      --primary: ${darkColors.primary};
      --primary-foreground: ${darkColors.primaryForeground};
      --secondary: ${darkColors.secondary};
      --secondary-foreground: ${darkColors.secondaryForeground};
      --muted: ${darkColors.muted};
      --muted-foreground: ${darkColors.mutedForeground};
      --accent: ${darkColors.accent};
      --accent-foreground: ${darkColors.accentForeground};
      --destructive: ${darkColors.destructive};
      --destructive-foreground: ${darkColors.destructiveForeground};
      --border: ${darkColors.border};
      --input: ${darkColors.input};
      --ring: ${darkColors.ring};
      --chart-1: ${darkColors.chart1};
      --chart-2: ${darkColors.chart2};
      --chart-3: ${darkColors.chart3};
      --chart-4: ${darkColors.chart4};
      --chart-5: ${darkColors.chart5};
      --sidebar: ${darkColors.sidebar};
      --sidebar-background: ${darkColors.sidebar};
      --sidebar-foreground: ${darkColors.sidebarForeground};
      --sidebar-primary: ${darkColors.sidebarPrimary};
      --sidebar-primary-foreground: ${darkColors.sidebarPrimaryForeground};
      --sidebar-accent: ${darkColors.sidebarAccent};
      --sidebar-accent-foreground: ${darkColors.sidebarAccentForeground};
      --sidebar-border: ${darkColors.sidebarBorder};
      --sidebar-ring: ${darkColors.sidebarRing};
      --success: ${darkColors.success};
      --success-foreground: ${darkColors.successForeground};
      --error: ${darkColors.error};
      --error-foreground: ${darkColors.errorForeground};
      --warning: ${darkColors.warning};
      --warning-foreground: ${darkColors.warningForeground};
      --info: ${darkColors.info};
      --info-foreground: ${darkColors.infoForeground};

      /* Dark Mode Shadows */
      --shadow-x: 0px;
      --shadow-y: 2px;
      --shadow-blur: 0px;
      --shadow-spread: 0px;
      --shadow-opacity: 0;
      --shadow-color: rgba(29,161,242,0.25);
      --shadow-2xs: ${darkShadows["2xs"]};
      --shadow-xs: ${darkShadows.xs};
      --shadow-sm: ${darkShadows.sm};
      --shadow: ${darkShadows.DEFAULT};
      --shadow-md: ${darkShadows.md};
      --shadow-lg: ${darkShadows.lg};
      --shadow-xl: ${darkShadows.xl};
      --shadow-2xl: ${darkShadows["2xl"]};
      --shadow-inner: ${darkShadows.inner};
    }

    @theme inline {
      --color-background: var(--background);
      --color-foreground: var(--foreground);
      --color-card: var(--card);
      --color-card-foreground: var(--card-foreground);
      --color-popover: var(--popover);
      --color-popover-foreground: var(--popover-foreground);
      --color-primary: var(--primary);
      --color-primary-foreground: var(--primary-foreground);
      --color-secondary: var(--secondary);
      --color-secondary-foreground: var(--secondary-foreground);
      --color-muted: var(--muted);
      --color-muted-foreground: var(--muted-foreground);
      --color-accent: var(--accent);
      --color-accent-foreground: var(--accent-foreground);
      --color-destructive: var(--destructive);
      --color-destructive-foreground: var(--destructive-foreground);
      --color-border: var(--border);
      --color-input: var(--input);
      --color-ring: var(--ring);
      --color-chart-1: var(--chart-1);
      --color-chart-2: var(--chart-2);
      --color-chart-3: var(--chart-3);
      --color-chart-4: var(--chart-4);
      --color-chart-5: var(--chart-5);
      --color-sidebar: var(--sidebar);
      --color-sidebar-foreground: var(--sidebar-foreground);
      --color-sidebar-primary: var(--sidebar-primary);
      --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
      --color-sidebar-accent: var(--sidebar-accent);
      --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
      --color-sidebar-border: var(--sidebar-border);
      --color-sidebar-ring: var(--sidebar-ring);
      --color-success: var(--success);
      --color-success-foreground: var(--success-foreground);
      --color-error: var(--error);
      --color-error-foreground: var(--error-foreground);
      --color-warning: var(--warning);
      --color-warning-foreground: var(--warning-foreground);
      --color-info: var(--info);
      --color-info-foreground: var(--info-foreground);

      --font-sans: var(--font-sans);
      --font-mono: var(--font-mono);
      --font-serif: var(--font-serif);

      --radius-sm: calc(var(--radius) - 4px);
      --radius-md: calc(var(--radius) - 2px);
      --radius-lg: var(--radius);
      --radius-xl: calc(var(--radius) + 4px);

      --shadow-2xs: var(--shadow-2xs);
      --shadow-xs: var(--shadow-xs);
      --shadow-sm: var(--shadow-sm);
      --shadow: var(--shadow);
      --shadow-md: var(--shadow-md);
      --shadow-lg: var(--shadow-lg);
      --shadow-xl: var(--shadow-xl);
      --shadow-2xl: var(--shadow-2xl);

      --tracking-tighter: calc(var(--tracking-normal) - 0.05em);
      --tracking-tight: calc(var(--tracking-normal) - 0.025em);
      --tracking-normal: var(--tracking-normal);
      --tracking-wide: calc(var(--tracking-normal) + 0.025em);
      --tracking-wider: calc(var(--tracking-normal) + 0.05em);
      --tracking-widest: calc(var(--tracking-normal) + 0.1em);
    }

    body {
      letter-spacing: var(--tracking-normal);
    }
  `
}

/**
 * Get the complete theme object
 * @returns {object} Theme configuration
 */
export function getTheme() {
  return theme
}

// Export individual pieces for convenience
export const colors = theme.colors
export const darkColors = theme.darkColors
export const spacing = theme.spacing
export const typography = theme.typography
export const radius = theme.radius
export const shadows = theme.shadows
export const darkShadows = theme.darkShadows
export const transitions = theme.transitions
export const zIndex = theme.zIndex
